<template>
    <div v-if="menuItem && selectedCrust" data-cy="size-choice">
        <ion-card-title data-cy="choose-crust-size-title" class="ion-text-center bold">
            Choose Your {{ menuItem.isPizza ? 'Crust' : menuItem.isMisc ? menuItem.name : menuItem.isSub ? 'Bun' : 'Size' }}
        </ion-card-title>
        <radiolist :aria-label="menuItem.recipes" v-if="menuItem.isPizza" :options="menuItem.recipes" keyName="recipeName" dense v-model="selectedCrust" data-cy="choose-size-pizza" />
        <radiolist :aria-label="menuItem.recipes" v-if="menuItem.isSub" :options="menuItem.recipes" keyName="recipeName" dense v-model="selectedCrust" data-cy="choose-size-pizza" />
        <radiolist
            :aria-labelledby="menuItem.recipes[0].sizes.sizePid"
            v-else-if="menuItem.isChicken"
            :options="menuItem.firstRecipe.sizes"
            keyName="pieces"
            dense
            v-model="selectedSize"
            sortKey="externalId"
            data-cy="choose-size-wings"
        />
        <radiolist
            :aria-labelledby="menuItem.recipes[0].sizes.sizePid"
            v-else-if="menuItem.isSalad"
            :options="menuItem.firstRecipe.sizes"
            keyName="partyName"
            dense
            v-model="selectedSize"
            data-cy="choose-size-salad"
        />
        <radiolist
            :aria-labelledby="menuItem.recipes[0].sizes.sizePid"
            v-else-if="menuItem.isDessert || menuItem.isBeverage || menuItem.isAppetizer || menuItem.isMisc"
            :options="menuItem.firstRecipe.sizes"
            keyName="sizeName"
            dense
            v-model="selectedSize"
            data-cy="choose-size-other"
        />

        <div v-if="menuItem.isPizza">
            <ion-item-divider class="ion-margin-vertical" />

            <ion-segment
                :aria-labelledby="menuItem.recipes[0].sizes.sizePid"
                mode="ios"
                v-if="selectedCrust.sizeDescending && selectedCrust.sizeDescending.length > 1"
                :value="selectedSize"
                @ionChange="selectSize($event.target.value)"
                class="ion-justify-content-start d-flex"
            >
                <ion-segment-button
                    :aria-labelledby="menuItem.recipes[0].sizes.sizePid"
                    v-for="size in selectedCrust.sizeDescending"
                    :key="size.name"
                    :value="size"
                    class="bold pills"
                    :data-cy="'button-choose-pizza-size-' + size.name"
                >
                    <ion-label :aria-labelledby="menuItem.recipes[0].sizes.sizePid">
                        {{ size.name }}
                    </ion-label>
                </ion-segment-button>
            </ion-segment>
            <ion-row class="ion-justify-content-center" data-cy="size-description">
                <ion-col v-if="selectedCrust.sizeDescending.length <= 1" class="ion-text-center ion-text-capitalize py-0" size="11">
                    <span v-html="selectedCrust.recipeName" /> is {{ selectedSize.number }}"
                </ion-col>
                <ion-col class="ion-text-center" size="11" data-cy="legal-description">
                    <ion-text color="primary">
                        {{ selectedCrust.legalDescription }}
                    </ion-text>
                </ion-col>
            </ion-row>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, watch } from 'vue';
import { IonCardTitle, IonLabel, IonItemDivider, IonSegment, IonSegmentButton, IonRow, IonCol, IonText } from '@ionic/vue';
import { MenuItem } from '@/models/menuModels';
import radiolist from '@/components/inputs/radiolist.vue';

export default defineComponent({
    props: { menuItem: { type: Object as PropType<MenuItem>, required: true } },
    components: { IonCardTitle, radiolist, IonLabel, IonItemDivider, IonSegment, IonSegmentButton, IonRow, IonCol, IonText },
    emits: ['size', 'crust'],
    setup(props, { emit }) {
        const selectedCrust = ref();
        const selectedSize = ref();
        const selectSize = (size) => {
            if (size) selectedSize.value = size;
            emit('size', size);
            emit('crust', selectedCrust.value);
        };

        const selectCrust = (crust) => {
            selectedCrust.value = crust;
            selectSize(crust.sizes.find((s) => s.preselected || s.name.includes(selectedSize.value?.name)) ?? crust?.sizeDescending[0]);
        };
        watch(selectedCrust, selectCrust);
        watch(selectedSize, selectSize);
        selectCrust(props.menuItem?.recipes?.find((r) => r.preselected) ?? props.menuItem?.firstRecipe);

        return { selectSize, selectedCrust, selectedSize };
    },
});
</script>
